import { getColor } from '../../colors/colors.alias';
import { getFontSize, getFontFamily, getLineHeight, } from '../../typography/typography.alias';
import { getHeight, getWidth } from '../../sizes/sizes.alias';
import getIcons from '../../icons/icons.alias';
import { constants as DatepickerDate } from '../DatepickerDate';
import { constants as Heading } from '../Heading';
import { constants as IconButton } from '../IconButton';
import { VARIANT_DEFAULT, VARIANT_NATIVE, ELEMENT_HEADING, ELEMENT_SWITCH_VIEW_BUTTON, ELEMENT_PREVIOUS_BUTTON, ELEMENT_NEXT_BUTTON, ELEMENT_DATE, ELEMENT_WEEKDAY, ELEMENT_DATEPICKER, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Datepicker',
    variants: {
        VARIANT_DEFAULT,
        VARIANT_NATIVE,
    },
    elements: {
        ELEMENT_HEADING,
        ELEMENT_SWITCH_VIEW_BUTTON,
        ELEMENT_PREVIOUS_BUTTON,
        ELEMENT_NEXT_BUTTON,
        ELEMENT_DATE,
        ELEMENT_WEEKDAY,
        ELEMENT_DATEPICKER,
    },
});
export default function getDatepicker(transformer, config) {
    const color = getColor(transformer, config);
    const fontFamily = getFontFamily(transformer, config);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const height = getHeight(transformer);
    const width = getWidth(transformer);
    const icons = getIcons();
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_HEADING]: {
                components: {
                    [Heading.NAME]: {
                        variant: Heading.variants.VARIANT_MEDIUM,
                    },
                },
            },
            [ELEMENT_SWITCH_VIEW_BUTTON]: {
                components: {
                    [IconButton.NAME]: {
                        variant: IconButton.variants.VARIANT_PLAIN_MEDIUM,
                        name: icons.form.datepicker.switchView.value,
                    },
                },
            },
            [ELEMENT_PREVIOUS_BUTTON]: {
                components: {
                    [IconButton.NAME]: {
                        variant: IconButton.variants.VARIANT_PLAIN_MEDIUM,
                        name: icons.action.previous.value,
                    },
                },
            },
            [ELEMENT_NEXT_BUTTON]: {
                components: {
                    [IconButton.NAME]: {
                        variant: IconButton.variants.VARIANT_PLAIN_MEDIUM,
                        name: icons.action.next.value,
                    },
                },
            },
            [ELEMENT_DATEPICKER]: {
                styles: {
                    height: height.datepicker.value,
                    width: width.datepicker.value,
                },
            },
            [ELEMENT_DATE]: {
                components: {
                    [DatepickerDate.NAME]: {
                        variant: DatepickerDate.variants.VARIANT_DEFAULT,
                    },
                },
            },
            [ELEMENT_WEEKDAY]: {
                styles: {
                    fontFamily: fontFamily.body.value,
                    fontSize: fontSize.form.datepicker.weekDay.value,
                    lineHeight: lineHeight.body.get(fontSize.form.datepicker.weekDay.value),
                    color: color.text.subtle.value,
                },
            },
        },
    });
}
